import React from "react";
import styled from "styled-components";
import Image from "gatsby-image";
import { graphql, StaticQuery } from "gatsby";

const Separator = styled.div`
  width: 102vw;
  margin-left: -1vw;
`;

export default () => (
  <StaticQuery
    query={graphql`
      {
        separatorImage: file(name: { eq: "knot-2x" }) {
          id
          name
          childImageSharp {
            fluid(maxWidth: 1800) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={props => {
      return (
        <Separator>
          <Image
            fluid={props.separatorImage.childImageSharp.fluid}
            alt="Twin-Taekwondo black belt banner"
          />
        </Separator>
      );
    }}
  />
);
